import { useEffect, useRef } from 'react';

// 29 unique images (duplicates from the "new 13" batch removed)
const AD_IMAGES = [
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775487575199_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486635018_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775483548990_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486370561_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775485743112_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486098427_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775485548296_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775487710257_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486540357_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486635959_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775487575096_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486370727_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775483548832_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775487575453_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775486540691_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775485548497_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775228370213_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775228370454_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775411179138_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775243716227_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775487709920_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775053021894_4.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775053021619_2.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775044469598_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1774912241402_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1774912241591_1.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1775043087662_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1774984790168_0.png',
  'https://whqgkwkhvrndgtnevfgr.supabase.co/storage/v1/object/public/ad-images/452dbc3f-8f54-406f-8c1f-422411eaff55/1774908568775_0.png',
];

// Distribute all 29 images across 3 columns — indices 0..28, no out-of-bounds
const COL_1_BASE = [
  AD_IMAGES[0], AD_IMAGES[3], AD_IMAGES[6], AD_IMAGES[9], AD_IMAGES[12],
  AD_IMAGES[15], AD_IMAGES[18], AD_IMAGES[21], AD_IMAGES[24], AD_IMAGES[27],
];
const COL_2_BASE = [
  AD_IMAGES[1], AD_IMAGES[4], AD_IMAGES[7], AD_IMAGES[10], AD_IMAGES[13],
  AD_IMAGES[16], AD_IMAGES[19], AD_IMAGES[22], AD_IMAGES[25], AD_IMAGES[28],
];
const COL_3_BASE = [
  AD_IMAGES[2], AD_IMAGES[5], AD_IMAGES[8], AD_IMAGES[11], AD_IMAGES[14],
  AD_IMAGES[17], AD_IMAGES[20], AD_IMAGES[23], AD_IMAGES[26],
];

// Duplicate each column for seamless infinite scroll
const COL_1 = [...COL_1_BASE, ...COL_1_BASE];
const COL_2 = [...COL_2_BASE, ...COL_2_BASE];
const COL_3 = [...COL_3_BASE, ...COL_3_BASE];

interface ScrollColumnProps {
  images: string[];
  direction: 'up' | 'down';
  speed: number;
}

function ScrollColumn({ images, direction, speed }: ScrollColumnProps) {
  const colRef = useRef<HTMLDivElement>(null);
  const posRef = useRef(0);
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const el = colRef.current;
    if (!el) return;

    // Wait one frame so the DOM has rendered and scrollHeight is accurate
    const startRaf = requestAnimationFrame(() => {
      const half = el.scrollHeight / 2;

      // For 'down' direction, start at the halfway point so it scrolls into view naturally
      if (direction === 'down') {
        posRef.current = -half;
      } else {
        posRef.current = 0;
      }

      const animate = () => {
        if (direction === 'up') {
          posRef.current -= speed;
          if (Math.abs(posRef.current) >= half) {
            posRef.current = 0;
          }
        } else {
          posRef.current += speed;
          if (posRef.current >= 0) {
            posRef.current = -half;
          }
        }
        el.style.transform = `translateY(${posRef.current}px)`;
        rafRef.current = requestAnimationFrame(animate);
      };

      rafRef.current = requestAnimationFrame(animate);
    });

    return () => {
      cancelAnimationFrame(startRaf);
      cancelAnimationFrame(rafRef.current);
    };
  }, [direction, speed]);

  return (
    <div ref={colRef} className="flex flex-col gap-3 will-change-transform">
      {images.map((src, i) => (
        <div
          key={i}
          className="relative w-full overflow-hidden rounded-xl flex-shrink-0"
          style={{ aspectRatio: '1 / 1' }}
        >
          <img
            src={src}
            alt="Ad Creative"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
        </div>
      ))}
    </div>
  );
}

export default function DemoSection() {
  return (
    <section className="py-24 bg-stone-950 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Real Results
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
            Ad creatives built by
            <br />
            <span className="bg-gradient-to-r from-orange-400 to-amber-300 bg-clip-text text-transparent">
              AdForge AI
            </span>
          </h2>
          <p className="text-lg text-white/60 max-w-xl mx-auto">
            Every image below was generated in under 30 seconds — no designer, no agency, no waiting.
          </p>
        </div>

        {/* Scrolling Gallery */}
        <div
          className="relative w-full overflow-hidden rounded-2xl"
          style={{ height: 560 }}
        >
          {/* Fade edges top & bottom */}
          <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-stone-950 to-transparent z-10 pointer-events-none" />
          <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-stone-950 to-transparent z-10 pointer-events-none" />

          <div className="flex gap-3 h-full px-1">
            {/* Column 1 — scrolls up */}
            <div className="flex-1 overflow-hidden">
              <ScrollColumn images={COL_1} direction="up" speed={0.4} />
            </div>
            {/* Column 2 — scrolls down */}
            <div className="flex-1 overflow-hidden">
              <ScrollColumn images={COL_2} direction="down" speed={0.35} />
            </div>
            {/* Column 3 — scrolls up, slightly faster */}
            <div className="flex-1 overflow-hidden">
              <ScrollColumn images={COL_3} direction="up" speed={0.45} />
            </div>
          </div>
        </div>

        {/* Bottom stats bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: 'ri-timer-line', value: '< 30 sec', label: 'Average generation time' },
            { icon: 'ri-file-copy-2-line', value: '12+ outputs', label: 'Hooks, headlines, CTAs, copy' },
            { icon: 'ri-image-line', value: 'Up to 6 images', label: 'AI creative images per run' },
            { icon: 'ri-apps-line', value: '5 platforms', label: 'Facebook, IG, Google, TikTok, LinkedIn' },
          ].map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center text-center bg-white/5 border border-white/10 rounded-2xl p-5 gap-2"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400">
                <i className={`${item.icon} text-lg`} />
              </div>
              <span className="text-2xl font-extrabold text-white">{item.value}</span>
              <span className="text-xs text-white/50 leading-tight">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
